{
    "Accessibility Menu": "Erişilebilirlik Menüsü",
    "Reset settings": "Ayarları Sıfırla",
    "Close": "Kapat",
    "Content Adjustments": "İçerik Ayarları",
    "Adjust Font Size": "Yazı Tipi Boyutunu Ayarla",
    "Highlight Title": "Başlığı Vurgula",
    "Highlight Links": "Bağlantıları Vurgula",
    "Readable Font": "Okunaklı Yazı Tipi",
    "Color Adjustments": "Renk Ayarları",
    "Dark Contrast": "Koyu Kontrast",
    "Light Contrast": "Açık Kontrast",
    "High Contrast": "Yüksek Kontrast",
    "High Saturation": "Yüksek Doygunluk",
    "Low Saturation": "Düşük Doygunluk",
    "Monochrome": "Tek Renkli",
    "Protanopia": "Protanopi",
    "Deuteranopia": "Deuteranopi",
    "Tritanopia": "Tritanopi",
    "Visual & Navigation Aids": "Görsel ve Gezinme Yardımcıları",
    "Additional Tools": "Ek Araçlar",
    "Reading Guide": "Okuma Rehberi",
    "Stop Animations": "Animasyonları Durdur",
    "Big Cursor": "Büyük İmleç",
    "Screen Reader": "Ekran Okuyucu",
    "Hide Images": "Görselleri Gizle",
    "Image Tooltips": "Görsel İpuçları",
    "Page Structure": "Sayfa Yapısı",
    "Super Focus": "Süper Odak",
    "Magnifier": "Büyüteç",
    "Increase Font Size": "Yazı Tipi Boyutunu Artır",
    "Decrease Font Size": "Yazı Tipi Boyutunu Azalt",
    "Letter Spacing": "Harf Aralığı",
    "Line Height": "Satır Yüksekliği",
    "Font Weight": "Yazı Tipi Kalınlığı",
    "Dyslexia Font": "Disleksi Yazı Tipi",
    "Language": "Dil",
    "Open Accessibility Menu": "Erişilebilirlik menüsünü aç",
    "Accessibility Profiles": "Erişilebilirlik Profilleri",
    "Seizure Safe Profile": "Nöbet Güvenli Profil",
    "Stops animations and reduces color saturation.": "Animasyonları durdurur ve renk doygunluğunu azaltır.",
    "Blind Profile": "Görme Engelli Profili",
    "Activates the screen reader for auditory navigation.": "İşitsel gezinme için ekran okuyucuyu etkinleştirir.",
    "Visually Impaired Profile": "Az Görmeli Profil",
    "Enhances contrast and readability for low vision.": "Az görme için kontrastı ve okunabilirliği artırır.",
    "ADHD Friendly Profile": "DEHB Dostu Profil",
    "Reduces distractions for better focus.": "Daha iyi odaklanmak için dikkat dağıtıcıları azaltır.",
    "Cognitive & Learning Profile": "Bilişsel ve Öğrenme Profili",
    "Helpful tools for reading and comprehension.": "Okuma ve anlama için yararlı araçlar.",
    "Motor Impaired Profile": "Motor Engelli Profil",
    "Optimizes the site for keyboard-only navigation.": "Siteyi yalnızca klavye navigasyonu için optimize eder.",
    "Headings": "Başlıklar",
    "Landmarks": "Yer İşaretleri",
    "Links": "Bağlantılar",
    "Focus element": "Öğeye odaklan",
    "Visit link": "Bağlantıyı ziyaret et"
}